/**
 * 접근 토큰을 어디에 두는가.
 *
 * ⚠ **localStorage 에는 절대 두지 않는다**(사장님 지시 9). 세션이 12시간이라
 * 브라우저를 닫아도 남는 저장소에 두면 공용 PC 에서 다음 사람에게 그대로 넘어간다.
 *
 * 메모리를 먼저 본다 — 탭이 살아 있는 동안은 그것으로 충분하고, 새로고침을
 * 견디는 몫만 sessionStorage 가 맡는다. sessionStorage 는 **탭 단위**라 탭을
 * 닫으면 사라지고 다른 탭과도 공유되지 않는다.
 *
 * ⚠ **sessionStorage 는 던질 수 있다.** 사생활 보호 모드나 사이트 데이터 차단
 * 설정에서는 접근 자체가 예외를 낸다. 그때도 앱은 돌아야 하므로 전부 감싼다 —
 * 그 경우 새로고침에 로그아웃될 뿐이다.
 */

const KEY = 'sjo.admin.token'

let inMemory: string | null = null

/**
 * 세션 세대 — 토큰을 넣거나 버릴 때마다 하나 는다.
 *
 * ⚠ **「같은 세션인가」만 묻는 자리다.** PIN 에 막혀 기억한 쓰기(pendingWrite.ts)는
 * 그 쓰기를 보낸 세션에서만 다시 나가야 한다. 로그인·로그아웃은 모두 여기를 지나므로
 * 번호가 다르면 다른 세션이다. 토큰 값을 다른 곳에 베껴 두지 않으려고 번호로 묻는다.
 */
let generation = 0

export function sessionGeneration(): number {
  return generation
}

export function setToken(token: string): void {
  generation++
  inMemory = token
  try {
    sessionStorage.setItem(KEY, token)
  } catch {
    // 저장 못 해도 이번 탭에서는 메모리로 돈다.
  }
}

export function getToken(): string | null {
  if (inMemory) return inMemory
  try {
    inMemory = sessionStorage.getItem(KEY)
  } catch {
    inMemory = null
  }
  return inMemory
}

export function clearToken(): void {
  generation++
  inMemory = null
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // 지우지 못해도 메모리는 비었다.
  }
}
